import ParamsPage from './list';

export default ParamsPage;
